module.exports = __webpack_public_path__ + "img/table-pivot.002d1e22.svg";